import { useQuery, UseQueryResult } from 'react-query';
import { ROUTES } from 'src/api/Routes';
import {
  getWhatsAppState,
  WhatsAppStateResponse,
  WhatsAppStatus,
} from 'src/components/WhatsAppConnector/api';

const PENDING_POLL_MS = 3000;
const IDLE_POLL_MS = 15000;

type WhatsAppStatusResult = UseQueryResult<WhatsAppStateResponse> & {
  isConnected: boolean;
  phone?: string;
};

/**
 * One shared poller for every consumer (settings connector, send-alert modal,
 * contract review). Baileys rotates the QR every ~20s, so poll fast while a
 * scan is pending and relax otherwise.
 */
export default function useWhatsAppStatus(
  enabled = true,
): WhatsAppStatusResult {
  const query = useQuery<WhatsAppStateResponse>(
    [ROUTES.GET.GET_WHATSAPP_STATE],
    getWhatsAppState,
    {
      enabled,
      staleTime: 2000,
      refetchIntervalInBackground: false,
      refetchInterval: (data) =>
        data?.status === WhatsAppStatus.PENDING
          ? PENDING_POLL_MS
          : IDLE_POLL_MS,
    },
  );
  return {
    ...query,
    isConnected: query.data?.status === WhatsAppStatus.CONNECTED,
    phone: query.data?.phone,
  };
}
